import { LOGO_URL } from "../constants";

const Logo = ({ size = "md" }) => {
    const dims = size === "lg" ? "h-10 sm:h-12" : "h-8 sm:h-9";
    return (
        <span className="inline-flex items-center gap-2.5 select-none" data-testid="brand-logo">
            <img src={LOGO_URL} alt="Sevano logo" className={`${dims} w-auto object-contain`} loading="eager" />
        </span>
    );
};

export default Logo;
